// extracted by mini-css-extract-plugin
export default {"add_btn":"Button_add_btn__CtDLx","save_btn":"Button_save_btn__HT1gR"};